// ============================================================================
// CheckboxGroup.jsx — Corelia UI v1.2
// Groupe de cases à cocher alignées H/V, cohérent avec RadioGroup & FormLayout
// - Intègre FormLayout (label / labelPosition / labelWidth / align / width)
// - Prop checkboxPosition: "right" (défaut, rétro) | "left" (checkbox à gauche)
// ============================================================================

import React from "react";
import theme from "../../../styles/theme";
import FormLayout from "./FormLayout";
import Checkbox from "./Checkbox";

const CheckboxGroup = ({
  label,
  labelPosition = "left",
  labelWidth = 120,
  align = "center",
  options = [],               // [{ label, value, checked }]
  onChange,                   // (value, newState) => {}
  orientation = "vertical",   // "horizontal" | "vertical"
  checkboxPosition = "right", // "left" | "right"
  disabled = false,
  width = "100%",
  style = {},
  checkboxStyle = {},
  rowGap = null,
  itemGap = null,
}) => {
  const isHorizontal = orientation === "horizontal";
  const isLeft = checkboxPosition === "left";

  return (
    <FormLayout
      label={label}
      labelPosition={labelPosition}
      labelWidth={labelWidth}
      align={align}
      width={width}
      style={style}
    >
      <div
        style={{
          display: "flex",
          flexDirection: isHorizontal ? "row" : "column",
          alignItems: isHorizontal ? "center" : "flex-start",
          gap: isHorizontal ? theme.spacing.lg : theme.spacing.md,
          opacity: disabled ? 0.6 : 1,
          cursor: disabled ? "not-allowed" : "default",
          fontFamily: theme.form.label.fontFamily,
          width: "100%",
          flexWrap: "nowrap",
          gap: isHorizontal ? theme.spacing.lg : (rowGap ?? theme.spacing.md),
        }}
      >
        {options.map((opt, index) => (
          <label
            key={opt.value ?? index}
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: theme.spacing.sm,
              width: "100%",

              marginBottom:
                !isHorizontal && index < options.length - 1
                  ? theme.spacing.xs
                  : 0,

              fontFamily: theme.form.field.fontFamily,
              fontSize: theme.form.field.fontSize,
              fontWeight: theme.form.field.fontWeight,
              color: disabled ? theme.colors.text.muted : theme.form.label.color,
              gap: itemGap ?? theme.spacing.sm,

              cursor: disabled ? "not-allowed" : "pointer",
              userSelect: "none",
            }}
          >
            {/* Checkbox à gauche (option) */}
            {isLeft && (
              <Checkbox
                label=""
                checked={!!opt.checked}
                disabled={disabled}
                onChange={(state) => !disabled && onChange?.(opt.value, state)}
                style={{ margin: 0 }}
                inputStyle={checkboxStyle}
              />
            )}

            {/* Label */}
            <span style={{ flex: 1 }}>{opt.label}
              
            </span>
            

            {/* Checkbox à droite (défaut) */}
            {!isLeft && (
              <Checkbox
                label=""
                checked={!!opt.checked}
                disabled={disabled}
                onChange={(state) => !disabled && onChange?.(opt.value, state)}
                style={{ margin: 0 }}
                inputStyle={checkboxStyle}
              />
            )}
          </label>
        ))}
      </div>
    </FormLayout>
  );
};

export default CheckboxGroup;